import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import Form from '@bingads-webui-component-legacy/form/view/simple-form';
import template from '@bingads-webui-campaign-legacy/adextension-shared/template/extension-editor.pug';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import SchedulingView from '@bingads-webui-campaign-legacy/adextension-shared/view/scheduling';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextension/shared');
const s$i18n = window.globalLegacyI18n.get('$/schema-i18n!campaign');

/**
 * Base class of AdExtension editor.
 * @class
 */
const ExtensionEditor = Form.extend({
  initialize({
    extension,
    schema,
    customValidators,
    fields,
    i18nKeys,
    data: {
      extension: repository,
    } = {},
    formatting = {
      // default css for label and controls
      labelClass: 'col-sm-4',
      controlClass: 'col-sm-8',
    },
    instrumentation = {
      startScenario: _.noop,
      startActivity: _.noop,
      logMessage: _.noop,
      endActivity: _.noop,
      asLoggingStart: _.constant(_.noop),
    },
    instrumentationSettings = {
      ACTIVITYNAME: {},
      SCENARIONAME: {},
    },
    disableScheduling = false,
  } = {}) {
    const permissions = config.get('Permissions') || {};

    this.isSchedulingEnabled = permissions.IsAdExtensionsSchedulingEnabled && !disableScheduling;
    this.repository = repository;

    this.instrumentation = instrumentation;
    this.instrumentationSettings = instrumentationSettings;

    Form.prototype.initialize.call(this, {
      model: extension,
      schema,
      customValidators,
      fields,
      s$i18n,
      template(params) {
        return template(_.extend({
          i18n,
          type: schema.name,
          formatting,
          editWarningMessage: i18n.get(i18nKeys && i18nKeys.AdExtensions_Edit_Warning ?
            i18nKeys.AdExtensions_Edit_Warning : 'AdExtensions_Edit_Warning'),
        }, params));
      },
    });


    if (this.isSchedulingEnabled) {
      this.model = _.pick(this.model, schema.key, 'Scheduling', ...this.properties);
      this.schedulingView = new SchedulingView(_.extend({}, formatting, { model: this.model.Scheduling || {} }));
    } else {
      this.model = _.pick(this.model, schema.key, ...this.properties);
    }

    this.on('save', (model) => {
      this._onSave(model);
    });
  },

  render() {
    Form.prototype.render.apply(this);

    if (this.isSchedulingEnabled) {
      this.schedulingView.render();
      this.$('.scheduling').replaceWith(this.schedulingView.el);
    }

    return this;
  },

  remove() {
    if (this.isSchedulingEnabled) {
      this.schedulingView.remove();
    }
    this.trigger('remove');
    Form.prototype.remove.apply(this);
  },

  validate() {
    if (this.upgradedUrlView && !this.upgradedUrlView.isValid()) {
      return false;
    }

    if (this.isSchedulingEnabled) {
      return _.every([this.schedulingView.validate(), Form.prototype.validate.apply(this)]);
    }
    return Form.prototype.validate.apply(this);
  },

  currentModel() {
    const baseModel = Form.prototype.currentModel.apply(this);

    if (this.isSchedulingEnabled) {
      baseModel.Scheduling = this.schedulingView.toObject();
    }

    return baseModel;
  },

  _onSave(model) {
    let scenario = this.viewModel.editing ?
        this.instrumentationSettings.SCENARIONAME.UpdateAdExtension :
        this.instrumentationSettings.SCENARIONAME.CreateAdExtension,
      saveActivity = this.instrumentationSettings.ACTIVITYNAME.SaveAdExtension;

    if (this.isSchedulingEnabled && this.schedulingView.modelChanged()) {
      this.instrumentation.asLoggingStart(_.noop, this.instrumentationSettings.ACTIVITYNAME.ChangeAdExtensionSchedule, scenario)();
    }

    this.instrumentation.startActivity(saveActivity);
    this.repository
      .create(model)
      .finally(withUiBlock(this.$el.parent()))
      .then((newModel) => {
        this.trigger(this.viewModel.editing ? 'updated' : 'created', newModel);
      })
      .catch((errors) => {
        if (errors instanceof this.repository.BadResponseError) {
          this.setErrors({
            $overall: [errors],
          });
        } else {
          let groupedErrors = _.groupBy(errors, 'property');

          if (this.upgradedUrlView) {
            const upgradedUrlFields = ['FinalUrls', 'MobileFinalUrls', 'TrackingUrlTemplate', 'UrlCustomParameters'];
            const upgradedUrlErrors = _.pick(groupedErrors, upgradedUrlFields);

            this.upgradedUrlView.handleApiErrors(upgradedUrlErrors);
            groupedErrors = _.omit(groupedErrors, upgradedUrlFields);
          }

          this.setErrors(groupedErrors);

          if (this.schedulingView && errors.Scheduling) {
            this.schedulingView.setErrors(errors.Scheduling);
          }
        }
      });
  },
});

export default ExtensionEditor;
